import { IDirection } from '@src/slide/domain/ui-model/element-modeles/transition/direction/interface';
import {
    SideDirectionType,
} from '@src/slide/domain/ui-model/element-modeles/transition/direction/constants';

export class SideDirection implements IDirection<SideDirectionType> {
    constructor(public data?: SideDirectionType) {}

    public get direction() {
        return this.data ?? SideDirectionType.LEFT;
    }

    public getDirectionType(isSwitchForward?: boolean): SideDirectionType {
        if (!isSwitchForward) {
            return this.direction;
        }
        switch (this.direction) {
            case SideDirectionType.UP:
                return SideDirectionType.DOWN;
            case SideDirectionType.DOWN:
                return SideDirectionType.UP;
            case SideDirectionType.LEFT:
                return SideDirectionType.RIGHT;
            case SideDirectionType.RIGHT:
                return SideDirectionType.LEFT;
        }
    }
}
